{
  "close": "סגור",
  "notifications": "התראות"
}
